<template>
    <v-container>
        <v-row>
            <v-img :src="require('@/assets/GofiQR-Vendlet.jpg')"/>
        </v-row>
        <v-row>
            <v-col md="8" align="left">
                <h1>Produktinformation</h1>
                <h3>Er det vigtigt for dig, at dine kunder har let adgang til vejledninger på de produkter, du har solgt dem? Så brug gofiqr.</h3>
                <p>
                    Med gofiqr-QR-koden på dine produkter sikrer du, at dine kunder altid har let adgang til dine vejledninger, instruktionsfilm og kontaktoplysninger.
                </p>

                <h2>Hvordan?</h2>
                <p>Du sætter QR-koden på dit produkt, inden du giver produktet til din kunde</p>
                <p>Din kunde, og alle andre brugere af produktet, kan nu til hver en tid tilgå din information med en telefons QR-kodescanner</p>
                <p>Alle informationer præsenteres i dit eget visuelle, professionelle univers, som er beskyttet mod reklamer</p>

                <h2>Brug den til:</h2>
                <p>Du sælger måske avancerede kopimaskiner, vaskemaskiner eller hjælpemidler til sundhedssektoren.</p>
                <p>Du bliver ofte forstyrret af kunder, der ikke kan finde produktmanualen, eller som er kommet til at anvende dit produkt forkert og nu beder om hjælp.</p>
                <p>Begge typer forstyrrelser kan du minimere med gofiqr. Dine kunder vil her scanne QR-koden, når de bliver usikre på brugen af dit produkt og hurtigt få adgang til din vejledning som kan være ren tekst, en pdf eller en film eller en lydfil.</p>

                <h3>gofiqr giver dig mulighederne. Du bestemmer indholdet.
                    gofiqr sørger for, at dine kunder altid har din information ved hånden.</h3>

                <v-divider class="mt-5"/>

                <v-row class="mt-5">
                    <v-col md="4">
                        <v-img :src="require('@/assets/vendlet01.jpeg')" max-width="300" aspect-ratio="1"/>
                    </v-col>
                    <v-col md="8">
                        <h2>Med gofiqr giver du dine kunder mulighed for at få:</h2>
                        <h3 class="mt-2">Opdateret produktinformation</h3>
                        <h3 class="mt-2">Vejledning til rådighed i brugssituationen</h3>
                        <h3 class="mt-2">Informationer på deres eget sprog</h3>
                        <h3 class="mt-2">Tryghed og sikkerhed</h3>
                    </v-col>
                </v-row>

                <v-divider class="my-5"/>

                <v-card flat link :to="{path: '/vendlet'}">
                    <h2>Hvem bruger gofiqr? Læs kundecase <b>HER</b></h2>
                </v-card>

                <v-divider class="my-5"/>
            </v-col>
            <v-col md="4" align="left">
                <ContactForm :know-more="true"/>
                <TryGofiqr/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ContactForm from "@/components/ContactForm";
    import TryGofiqr from "@/components/TryGofiqr";

    export default {
        name: 'ProductinformationPage',
        components: {TryGofiqr, ContactForm}
    }
</script>

